import { Card, Container, Divider, Grid, Stack, Typography } from '@mui/material';
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import FordImageComponent from '../../components/fordImageComponent';
import PopUp from "../../components/popup/Popup";
import RefreshIconComponent from '../../components/refreshIconComponent';
import config from "../../config";
import { dashBoardListAsync } from '../../redux/actions/dashboardSlice';
import { useAppDispatch, useAppSelector } from '../../store/customHooks';
import PaginationComponent from './Pagination';


const useStyles = makeStyles((theme: any) => ({
  root: {
    // height: "70vh",
    display: "flex",
    marginRight: 10
  },
  card: {
    maxWidth: '100%',
    width: '100%',
    marginBottom: '15px'
  },
  textAlignment: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: '2px 20px'
  },
  divider: {
    backgroundColor: '#ffffff',
    display: 'flex',
    borderBottom: '1px solid #d3d3d3'
  },
  headerText: {
    display: 'flex',
    width: '100%',
    //backgroundColor: '#3E62A4'
  },
  subtitle: {
    color: '#fff',
    fontSize: '14px'
  },
  bottomBackground: {
    // padding: '10px',
    backgroundColor: '#F5F5F5'
  },
  ItemText: {
    fontWeight: '500',
    color: '#000000',
    lineHeight: '0rem'
  },
  fordImage: {
    width: "430px",
    height: '380px'
  },
  pagination: {
    display: 'flex', justifyContent: 'left',
  },
  text: {
    color: '#fff', fontSize: '14px'
  },
}));

const Item = styled("div")(({ theme }) => (
  {
    ...theme.typography.body2,
    padding: theme.spacing(2),
    // textAlign: "center",
    fontSize: '12px',
    fontWeight: '500', color: '#000000',
  }));

const PAGE_SIZE = 5;
export const WelcomeBoard = (props: any) => {
  const {socket}=props;
  const authData = JSON.parse(localStorage.getItem("AUTH_DATA") || "{}");
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [data, setData]: any = useState([]);
  const [open, setOpen] = useState(false);
  const [pagination, setPagination] = useState({
    start: 0,
    end: PAGE_SIZE
  })
  let dashBoardData = useAppSelector((state: any) => state.dashboard.dashBoardData);
  useEffect(() => {
    getList();
    if (socket) {
      socket.emit("joinRoom", 'AppointmentSummary:'+authData?.CompanyID)}
  }, [])
 
  

  let interval: any;
  useEffect(() => {
    if (socket) {
      //socket.emit("joinRoom", 'AppointmentSummary:'+authData?.CompanyID)
      socket?.on('AppointmentSummary:'+authData?.CompanyID, (dataSI: any) => {
        let IDFound = false

        if (dataSI?.CompanyID == authData?.CompanyID && dataSI?.RelationKey == authData?.referenceData?.defaultBranch) {
          clearInterval(interval)
          getList()
        }
      });
    }
    return () => {
      socket.off('AppointmentSummary');
    };
  }, [socket]);

  const [totalCount, setTotalCount] = useState([])
  useEffect(() => {
    if (dashBoardData) {
      setData(dashBoardData?.data);
      setTotalCount(dashBoardData?.data)
      autoLoadList(dashBoardData?.data)
    } else {
      setData([])
      setTotalCount([])
    }
    return () => {
      setData([])
      setTotalCount([])
      clearInterval(interval)
    }
  }, [dashBoardData, pagination]);

  const getList = async () => {
    const payload = {
      "CompanyID": authData?.CompanyID.toString()
    };

    const res: any = await dispatch(dashBoardListAsync(payload));
    if (!(res && res?.payload && res?.payload?.success)) {
      setOpen(true);
    }
  };
  const autoLoadList = (dataAuto: any) => {

    let endofpage: any = null;
    let startofpage: any = null;

    if (dataAuto?.length > 0) {

      const getRows = (st: number, end: number) => {
        let currentRows = dataAuto.slice(st, end)
        setData(currentRows)
        start = start + pageSize
        startofpage = start
        end = end + pageSize
        endofpage = end

        pageCount = pageCount - 1;

      }

      let pageSize: number = 5
      let totalPageCount: number = dataAuto.length / pageSize
      let pageCount: number = parseInt(totalPageCount.toFixed());

      let finalPageCount: number = 0
      if (totalPageCount > pageCount) {

        pageCount = pageCount + 1;
        finalPageCount = pageCount
      }
      else
        finalPageCount = pageCount;

      let start: number = 0;
      let end: number = pageSize;

      getRows(start, end)

      interval = setInterval(() => {

        if (Math.max(pageCount, 0) === 0) {
          pageCount = finalPageCount
          start = 0;
          end = pageSize;
          startofpage = 0;
          endofpage = 5;

          getRows(startofpage, endofpage)
          // return () => {
          //   clearInterval(interval);
          // };
        }
        else {
          getRows(startofpage, endofpage)
        }

      }, 30000);
    }
  }
  const onPaginationChange = (start: number, end: number) => {

    setPagination({ start, end })
  }

  const reload = async (e: any) => {
    e.preventDefault();
    getList();
  };

  const handleClose = () => {
    setOpen(false);
    localStorage.removeItem("AUTH_DATA");
    navigate("/login");
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Header position={'static'} />
        </Grid>

        <RefreshIconComponent onClick={(e: any) => { reload(e) }} />

        <Container className={classes.root}>
          <Grid container >
            <Grid item xs={12} sm={12} md={5} >
              <FordImageComponent classes={classes} />
            </Grid>

            <Grid item xs={12} sm={12} md={7} >
              {data?.map((item: any) => {
                return <Card className={classes.card} key={item.SrNo}>
                  <div className={classes.divider}>
                    <div className={classes.headerText}
                      style={{
                        //backgroundColor:  moment(item.AppointmentDate).format("YYYY-MM-DDTHH:mm:ss") < moment().format("YYYY-MM-DDTHH:mm:ss") ? 'red' :'#3E62A4'
                        backgroundColor: item.Status === 'Closed' ? 'green' : item.Status === 'No Show Up' || moment(item.AppointmentDate).format("YYYY-MM-DDTHH:mm:ss") < moment().format("YYYY-MM-DDTHH:mm:ss") ? 'red' : '#3E62A4'

                      }}>

                      <Grid item xs={12} sm={12} >
                        <Grid container >
                          <Grid item xs={6} sm={6} className={classes.textAlignment}>
                            <Typography className={classes.text}>{item.GuestName}</Typography>
                          </Grid>
                          <Grid item xs={6} sm={6} style={{ display: 'flex', flex: 1, padding: '2px 20px', justifyContent: 'flex-end', }}>
                            <Typography className={classes.text}>{moment(item.AppointmentDate).format("LLL")} </Typography>
                          </Grid>

                        </Grid>
                      </Grid>
                    </div>
                  </div>
                  <Grid container className={classes.bottomBackground}>
                    <Grid item sm={4} textAlign={"left"}>
                      <Item>SA Name:{item.SalesPersonName}</Item>
                    </Grid>
                    <Grid item sm={4} textAlign={"center"}>
                      <Item> Model:&nbsp;{item.ModelName}</Item>
                    </Grid>
                    <Grid item sm={4} textAlign={"right"}>
                      <Item >Reg No:&nbsp;{item.RegistrationNo}</Item>

                    </Grid>
                    <Stack direction="row">

                      {/* <Divider orientation="vertical" variant="middle" flexItem sx={{ borderRightWidth: 1, borderColor: 'black', marginTop: '8px', height: '18px' }} />
                     
                      <Divider orientation="vertical" variant="middle" flexItem sx={{ borderRightWidth: 1, borderColor: 'black', marginTop: '8px', height: '18px' }} />
                     */}

                    </Stack>
                  </Grid>
                </Card >
              })}
              <Grid item xs={12} className={classes.pagination}>

                {data?.length > 0 && <PaginationComponent pageSize={PAGE_SIZE} onPaginationChange={onPaginationChange} total={totalCount?.length} noRecordPerpage={data?.length} />}

              </Grid>
            </Grid>

            <PopUp open={open} handleClose={handleClose} />
          </Grid>
        </Container>
      </Grid>
    </>
  )
}